import type * as z from 'zod';

import { productAndServiceTemplateQuerySchema } from './products-and-services-template-query-schema';

export const productAndServiceTemplateMutationSchema = productAndServiceTemplateQuerySchema
  .omit({ product_template_items: true })
  .extend({});

export type ProductAndServiceTemplateMutationSchema = z.infer<typeof productAndServiceTemplateMutationSchema>;

export const productAndServiceTemplateCreateSchema = productAndServiceTemplateMutationSchema.omit({
  id: true,
});

export type ProductAndServiceTemplateCreateSchema = z.infer<typeof productAndServiceTemplateCreateSchema>;
